import Image from "@/components/AppImage";
import Link from "@/components/common/DashboardLink";
import right_arrow from "/public/images/icon/right-arrow.png";
import recipients_1 from "/public/images/recipients-1.png";
import recipients_2 from "/public/images/recipients-2.png";
import recipients_3 from "/public/images/recipients-3.png";
import recipients_4 from "/public/images/recipients-4.png";

const Recipients = () => {
  return (
    <div className="single-item">
      <div className="section-text d-flex align-items-center justify-content-between">
        <h6>Recent counterparties</h6>
        <div className="view-all d-flex align-items-center">
          <Link href="/recipients">View All</Link>
          <Image src={right_arrow} alt="icon" />
        </div>
      </div>
      <ul className="recipients-item">
        <li>
          <p className="left d-flex align-items-center">
            <Image src={recipients_1} alt="icon" />
            <span className="info">
              <span>Treasury · Polygon</span>
              <span>USDC payout · 08:00 AM — 19 Mar</span>
            </span>
          </p>
          <p className="right">
            <span className="amount-out">−420 USDC</span>
            <span>Send</span>
          </p>
        </li>
        <li>
          <p className="left d-flex align-items-center">
            <Image src={recipients_2} alt="icon" />
            <span className="info">
              <span>Chase •••• 3210</span>
              <span>ACH deposit · 07:30 AM — 18 Mar</span>
            </span>
          </p>
          <p className="right">
            <span className="loss">NSF return</span>
            <span>ACH</span>
          </p>
        </li>
        <li>
          <p className="left d-flex align-items-center">
            <Image src={recipients_3} alt="icon" />
            <span className="info">
              <span>Auto-convert</span>
              <span>USDC → POL · 06:10 PM — 17 Mar</span>
            </span>
          </p>
          <p className="right">
            <span>+612 POL</span>
            <span>Convert</span>
          </p>
        </li>
        <li>
          <p className="left d-flex align-items-center">
            <Image src={recipients_4} alt="icon" />
            <span className="info">
              <span>Vendor wallet</span>
              <span>USDC received · 04:00 PM — 16 Mar</span>
            </span>
          </p>
          <p className="right">
            <span>+900 USDC</span>
            <span>Receive</span>
          </p>
        </li>
      </ul>
    </div>
  );
};

export default Recipients;
